import React from 'react';
import { DomainPropType, VictoryAxis, VictoryBar, VictoryLabel, VictoryTooltip } from 'victory';
import { IDateValue } from '../../lib/helpers/types';
import { QualaRange } from '../../lib/qualaRange';
import QualaChart from './QualaChart';

interface IFiverChartProps {
  averagePoints: IDateValue[];
  range: QualaRange;
  small?: boolean;
  short?: boolean;
}
class FiverChart extends React.Component<IFiverChartProps, {}> {
  public static defaultProps = {
    range: null,
    measurementPoints: null,
    averagePoints: null,
    short: false
  };

  public render() {
    const { range, averagePoints, short = false } = this.props;
    const tickCount = range.timescale === 'month' ? 5 : undefined;
    const domain: DomainPropType = { y: [1, 5] };
    domain.y = [1, 5];

    return (
      <QualaChart domain={domain} short={short}>
        <VictoryAxis
          dependentAxis={true}
          tickFormat={t => Math.round(t)}
          tickLabelComponent={<VictoryLabel dx={12} dy={10} textAnchor="start" />}
          style={{
            axis: { stroke: 'transparent' }
          }}
        />
        <VictoryAxis
          crossAxis={true}
          tickValues={range.ticks()}
          tickFormat={t => range.formatTick(t)}
          tickCount={tickCount}
          style={{
            grid: { stroke: 'transparent' }
          }}
        />

        {averagePoints && averagePoints.length > 0 && (
          <VictoryBar
            data={averagePoints}
            x="date"
            y="value"
            labelComponent={<VictoryTooltip />}
            animate={{
              duration: 500,
              onLoad: { duration: 750 }
            }}
          />
        )}
      </QualaChart>
    );
  }
}

export default FiverChart;
